import { IDropdownOption, Stack, makeStyles } from '@fluentui/react';
import { FormHookDropdown } from 'common/components/FormHooksFields';
import { FormHookCheckBox } from 'common/components/FormHooksFields/FormHookCheckBox';
import React from 'react';
import { DataAccessPolicyCommonData_companyBusinessUnits } from '../../__generated__/DataAccessPolicyCommonData';

const useStyles = makeStyles(() => ({
  container: {
    width: '50%',
  },
  currency: {
    width: '60%',
  },
  isPrimary: {
    width: '40%',
  },
}));

interface FormFieldsProps {
  baseField: string;
  businessUnitAccessDisabled: boolean;
  companyBusinessUnits:
    | DataAccessPolicyCommonData_companyBusinessUnits
    | null
    | undefined;
  isUpdatable: boolean;
  onPrimaryChange: (param: boolean) => void;
}

export const FormFields: React.FC<FormFieldsProps> = ({
  baseField,
  businessUnitAccessDisabled,
  companyBusinessUnits,
  isUpdatable,
  onPrimaryChange,
}) => {
  const styles = useStyles();
  const { nodes } = { ...companyBusinessUnits };

  const businessUnitOptions: IDropdownOption[] =
    nodes?.map((ele) => {
      return {
        key: ele.id,
        text: ele.name || '',
      };
    }) || [];

  return (
    <Stack
      horizontal
      verticalAlign="end"
      className={styles.container}
      tokens={{ childrenGap: 50 }}
    >
      <Stack.Item className={styles.currency}>
        <FormHookDropdown
          name={`${baseField}.businessUnitId`}
          options={businessUnitOptions}
          disabled={businessUnitAccessDisabled}
        />
      </Stack.Item>
      <Stack.Item className={styles.isPrimary}>
        <FormHookCheckBox
          name={`${baseField}.isPrimary`}
          label="Primary"
          disabled={!isUpdatable}
          onChange={(_e, checked) => {
            onPrimaryChange(!!checked);
          }}
        />
      </Stack.Item>
    </Stack>
  );
};
